<template lang="pug">
  .job-menu(:class="{ active: checked }")
    p(v-if="checkedCount > 0")
      span(v-if="spMode") {{ checkedCount }}件のリストを選択
      span(v-else) {{ checkedCount }}件のリストを一覧から選択しています。
      span
        a(@click="uncheckAll") チェック解除
    ul
      li
        a.button-sub(@click="addToMyList" :disabled="disabled") リストに追加
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import { HumanErrorMessages, HumanInfoMessages } from '../../constants'

  export default {
    props: ['checkedIds'],
    computed: {
      ...mapGetters('startingBusiness', ['checked', 'checkedCount']),
      ...mapGetters('common', ['spMode', 'downloading']),
      ...mapGetters('user', ['demo']),
      ...mapGetters({
        locked: 'common/isGlobalLocked',
      }),
      disabled () {
        return this.locked || this.downloading
      },
    },
    methods: {
      ...mapActions('startingBusiness', ['removeCheckedStartingBusinesses']),
      ...mapMutations('startingBusiness', ['uncheckAll', 'clearDetail']),
      openCsvDownloadModal () {
        if (this.demo) {
          this.$store.dispatch('common/pushToastError', {
            error: new Error(HumanErrorMessages.FORBIDDEN),
          })
          return
        }

        if (this.checkedCount > 0) {
          this.$store.commit('common/setJobModalMode')
          this.$store.commit('common/showModal')
        }
      },
      async addToMyList () {
        this.clearDetail()
        this.$store.commit('common/lockGlobal')
        const ids = this.checkedIds
        try {
          await this.$store.dispatch('startingBusinessList/add', { ids })
          this.$store.commit('startingBusiness/uncheck', ids)
          this.$store.commit('startingBusiness/favor', { ids, newFavored: true })
          this.$store.dispatch('common/pushToastInfo', {
            info: HumanInfoMessages.ADDED_TO_STARTING_BUSINESS_LIST,
          })
        } catch (e) {
          this.$store.dispatch('common/pushToastError', {
            error: e,
          })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessMenu.vue